interface MarkdownContentProps {
  content: string;
}

export function MarkdownContent({ content }: MarkdownContentProps) {
  const blocks = content.split(/\n{2,}/);

  return (
    <article className="markdown-content">
      {blocks.map((block, index) => {
        const trimmed = block.trim();
        if (!trimmed) return null;

        if (trimmed.startsWith('```')) {
          const code = trimmed.replace(/^```[\w-]*\n?/, '').replace(/```$/, '');
          return (
            <pre key={index} className="markdown-content__code">
              <code>{code}</code>
            </pre>
          );
        }

        if (trimmed.startsWith('# ')) {
          return (
            <h2 key={index} className="markdown-content__h2">
              {trimmed.slice(2)}
            </h2>
          );
        }

        if (trimmed.startsWith('## ')) {
          return (
            <h3 key={index} className="markdown-content__h3">
              {trimmed.slice(3)}
            </h3>
          );
        }

        if (trimmed.startsWith('- ')) {
          const items = trimmed.split('\n').map((line) => line.replace(/^- /, ''));
          return (
            <ul key={index} className="markdown-content__list">
              {items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        }

        return (
          <p key={index} className="markdown-content__p">
            {trimmed}
          </p>
        );
      })}
    </article>
  );
}
